module.exports = __webpack_public_path__ + "img/04.19be263a.jpg";